import {
  Component,
  inject,
  ChangeDetectionStrategy,
  computed,
} from '@angular/core';
import { Router } from '@angular/router';
import { BrandService } from 'app/core/services/brand.service';
import { JWTService } from 'app/core/services/jwt.service';
import { UserRole } from 'app/core/enums/user-role.enum';

/**
 * Topbar Component - Angular 19
 * Barra superior com logo, notificações e menu de usuário
 */
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TopbarComponent {
  private readonly brandService = inject(BrandService);
  private readonly router = inject(Router);
  private readonly jwtService = inject(JWTService);

  brandConfig = this.brandService.config;

  /**
   * Verifica se o usuário pode criar leads
   * Apenas ADMIN e SALES_REP podem criar leads
   * FIELD_SALES e SALES_OPS têm acesso READ ONLY
   */
  podeCriarLead = computed(
    () =>
      this.jwtService.isRole(UserRole.ADMIN) ||
      this.jwtService.isRole(UserRole.SALES_REP),
  );

  criarLead(): void {
    this.router.navigate(['/leads/criar']);
  }
}
